<template>
  <div>
  <i class="fa-star"
     v-bind:class="{ fas: flooredRating >= 1 , far: flooredRating < 1 }"></i>
  <i class="fa-star"
     v-bind:class="{ fas: flooredRating >= 2 , far: flooredRating < 2 }"></i>
  <i class="fa-star"
     v-bind:class="{ fas: flooredRating >= 3 , far: flooredRating < 3 }"></i>
  <i class="fa-star"
     v-bind:class="{ fas: flooredRating >= 4 , far: flooredRating < 4 }"></i>
  <i class="fa-star"
     v-bind:class="{ fas: flooredRating === 5 , far: flooredRating !== 5 }"></i>
  </div>
</template>

<script>
export default {
  props: {
    rating: Number
  },
  computed: {
    flooredRating () {
      return Math.floor(this.rating)
    }
  }
}
</script>

<style scoped>
.fa-star {
  color: orange;
}
</style>



// WEBPACK FOOTER //
// src/components/business/Stars.vue